import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import StateContext from "../../contexts/StateContext";
import FormStatistics from "../forms/FormStatistics";

function Statistics(props) {
  const appState = useContext(StateContext);
  const history = useHistory();

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  return (
    <main className="statistics">
      <h1 className="title">Statistik</h1>
      <p className="intro">In diesem Bereich können Sie individuelle Auswertungen und Statistiken abrufen.</p>
      <FormStatistics
        userType={appState.user.navType}
        onCancel={e => {
          history.push("/");
        }}
      />
    </main>
  );
}
export default Statistics;
